import React from 'react';
// import Logger from '../../util/Logger';
import $ from 'jquery';
import './Tooltip.css';

/**
 * Tooltip class
 *
 * tooltip - The tooltip text, must be a string. Crashes if omitted.
 * placement - position for tooltip, things like 'top' 'bottom'. Must be a string. defaults to top.
 *
 * Use like this:
 *
 * render () {
 *    ...
 *    <Tooltip tooltip={tooltip text here}>
 *      <div>
 *        ... Anything you want to hover over to display Tooltip ...
 *      </div>
 *    </Tooltip>
 * }
 */
export default class Tooltip extends React.Component {

  // constructor (props) {
  //   super(props);

  //   const { children, tooltip } = props;
  //   if (!children) {
  //     Logger.assert('Must create Tooltip around some children nodes');
  //   }

  //   if (!tooltip) {
  //     Logger.assert('Tooltip must have title property');
  //   }
  // }

  render () {
    const { children, tooltip, callback, id } = this.props;
    const placement = this.props.placement || 'top';

    const template = `
    <div class="pop-tooltip tooltip" role="tooltip">
      <div class="arrow"></div>
      <div class="pop-tooltip-inner tooltip-inner"></div>
    </div>
`;
    return (
      <div
        id={id}
        data-toggle="tooltip"
        data-template={ template }
        data-placement={ placement }
        data-trigger="hover manual"
        title={ tooltip }
        onMouseOver={ callback }>
        { children }
      </div>
    );
  }

  componentDidMount () {
    const {id} = this.props;
    const tooltip = $('[data-toggle="tooltip"]');
    if (tooltip && tooltip.tooltip) {
      tooltip.tooltip();
    }
    if (!!id) {
      const element = $(`#${id}`);
      element.tooltip('show');
    }
  }

  componentWillUnmount () {
    const tooltip = $('[data-toggle="tooltip"]');
    if (tooltip && tooltip.tooltip) {
      tooltip.tooltip('dispose');
    }
  }

}
